import {
    LOGOUT_ERROR,
    LOGOUT,
    LOGIN_ERROR,
    LOGIN,
    REFRESH_ERROR,
    REFRESH,
    VALIDATE_TOKEN,
    VALIDATE_TOKEN_ERROR,
    GET_REPORTS_ERROR,
    GET_REPORTS,

} from '../actions/actions.js'
import {
    CLEAR_BASIC_ERRORS,
    DELETE_REPORT, DELETE_REPORT_ERROR,
    GET_HOSPITAL, GET_HOSPITAL_ERROR, POST_REPORT, POST_REPORT_ERROR,
    SET_LOADING, UPDATE_HOSPITAL, UPDATE_HOSPITAL_ERROR,
    UPDATE_VALUES,
    UPDATE_VALUES_ERROR, UPLOAD_XML, UPLOAD_XML_ERROR,
    WAIT_FOR_TOKEN
} from "../actions/actions";

const initialState = {
    jwt: null,
    expiryDate: null,
    name: null,
    error: null,
    msg: null,
    loading: false,
    reports: [],
    hospital: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOGOUT:
            return {
                ...state,
                expiryDate: null,
                name: null,
                jwt: null,
                error: null
            };
        case LOGIN:
            return {
                ...state,
                jwt: action.payload,
                loading: false,
                error: null,
            };
        case WAIT_FOR_TOKEN:
            return {
                ...state,
                loading: action.payload,
                error: null
            };
        case VALIDATE_TOKEN:
            return {
                ...state,
                expiryDate: action.payload.expiryDate,
                name: action.payload.name,
                jwt: action.payload.jwt,
                error: null
            };
        case REFRESH:
            return {
                ...state,
                jwt: action.payload,
                error: null
            };
        case LOGIN_ERROR:
            console.error(action.payload);
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case LOGOUT_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        case REFRESH_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        case VALIDATE_TOKEN_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        case GET_REPORTS:
            return {
                ...state,
                reports: action.payload
            };
        case GET_REPORTS_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case UPDATE_VALUES:
            return {
                ...state,
                reports: [...state.reports.filter(report => report.id !== action.payload.id), action.payload]
            };
        case UPDATE_VALUES_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case UPLOAD_XML:
            return {
                ...state,
                reports: [...state.reports.filter(report => report.id !== action.payload.id), action.payload],
                error: "Pomyślnie dodano sprawozdanie"
            };
        case UPLOAD_XML_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case GET_HOSPITAL:
            return {
                ...state,
                hospital: action.payload
            };
        case GET_HOSPITAL_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case UPDATE_HOSPITAL:
            return {
                ...state,
                hospital: action.payload
            };
        case UPDATE_HOSPITAL_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case POST_REPORT:
            return {
                ...state,
                reports: [...state.reports, action.payload]
            };
        case POST_REPORT_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case DELETE_REPORT:
            return {
                ...state,
                reports: state.reports.filter((x) => x.id !== action.payload)
            };
        case DELETE_REPORT_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case CLEAR_BASIC_ERRORS:
            return {
                ...state,
                error: null
            };
        default:
            return state;
    }
};
